import React from 'react';
import { useUrlLocalizer, useTranslator } from 'tradera-lang';
import ALink from 'tradera-components/alink/alink';
import { trackContainerClick } from '../analytics';
import './favourite-sellers.scss';

const FavouriteSellerCard = ({
    sellerAlias,
    sellerId,
    matchedItems,
    hasShop,
    heroImageUrl,
    items
}) => {
    const { t } = useTranslator();
    const { toLocalizedUrl } = useUrlLocalizer();

    return (
        <div className={`favourite-seller-card`}>
            <div
                className="favourite-seller-card-image d-flex flex-column align-items-center position-relative"
                style={{
                    backgroundImage:
                        heroImageUrl &&
                        `url(https://img.tradera.net/heroimages/min/${heroImageUrl})`
                }}>
                {hasShop && (
                    <span className="shop-badge badge badge-dark mt-1 mr-2">
                        {t('startPage_favouriteSellers_sellerCard_shopBadge')}
                    </span>
                )}
                <div className="seller-alias p-2">
                    <h5 className="h5 mb-0 ">
                        <ALink
                            className="text-truncate text-styled text-white"
                            href={toLocalizedUrl(
                                `/profile/items/${sellerId}/${sellerAlias}`
                            )}
                            onClick={() =>
                                trackContainerClick(
                                    'favouriteSeller',
                                    'Favourite Seller Card title'
                                )
                            }
                            useLink={false} // Use 'inSPA' when mytradera-page can be rnavigated to without a hard reload
                        >
                            {sellerAlias}
                        </ALink>
                    </h5>
                </div>
            </div>
            {items && items.length > 0 && (
                <div className="favourite-seller-card-items pt-1 d-flex overflow-hidden">
                    {items.map(item => (
                        <ALink
                            className="mini-image-card p-2"
                            href={toLocalizedUrl(item.itemUrl)}
                            key={item.itemId}
                            onClick={() =>
                                trackContainerClick(
                                    'favouriteSeller',
                                    'Favourite Seller Card item'
                                )
                            }
                            useLink={false} // Use 'inSPA' when mytradera-page can be rnavigated to without a hard reload
                        >
                            <img
                                src={item.imageUrl.replace(
                                    '/thumbs/',
                                    '/small-fit/'
                                )} // TODO: Use correct image size.
                                title={item.shortDescription}
                                alt={item.shortDescription}
                            />
                        </ALink>
                    ))}
                </div>
            )}
            <div className="w-100 p-1">
                <ALink
                    className="btn btn-fluid btn-outline-primary px-2 text-truncate"
                    href={toLocalizedUrl(
                        `/profile/items/${sellerId}/${sellerAlias}`
                    )}
                    onClick={() =>
                        trackContainerClick(
                            'favouriteSeller',
                            'Favourite Seller Card button below'
                        )
                    }
                    useLink={false} // Use 'inSPA' when mytradera-page can be rnavigated to without a hard reload
                >
                    {t('startPage_favouriteSellers_sellerCard_count', {
                        count: matchedItems
                    })}
                </ALink>
            </div>
        </div>
    );
};

export default FavouriteSellerCard;
